import { ready } from '~/core'
import addEvents from '~/utils/addEvents'

ready('tru-dialog', '.tru-dialog', (dialog) => {
  // Modal Setup
  const modal = dialog;
  const closeBtn = modal.querySelector('.tru-dialog__close');
  const title = modal.querySelector('.tru-dialog__title');
  const icon = modal.querySelector('.tru-dialog__icon');
  const content = modal.querySelector('.tru-dialog__content');
  const openLinks = document.querySelectorAll('.tru-dialog__open-link');

  if (closeBtn) {
    addEvents(closeBtn, 'click', () => {
      modal.close();
      content.innerHTML = '';
      title.innerHTML = '';
      icon.removeAttribute('src');
    });
  }

  if (openLinks.length)
    openLinks.forEach(bindOpenModal);

  // Allow Dynamic Binding
  if (!window.bindOpenModalLink)
    window.bindOpenModalLink = bindOpenModal;


  // - Functions - //

  // Get link configurations 
  function initLinkConfig(link) {
    const style = link.dataset.style;
    const contentId = link.dataset.modalId;
    const iconSrc = link.dataset.iconSrc;

    let modalContent;
    let titleText = link.dataset.modalTitle;

    if (contentId) {
      modalContent = document.querySelector(`.tru-dialog__modal-content[data-modal-id="${contentId}"]`);
    } else {
      const linkParent = link.closest('.tru-dialog__open-link-reference') || link.parentElement;
      modalContent = linkParent?.querySelector('.tru-dialog__modal-content');
    }

    titleText = titleText || (modalContent ? modalContent.dataset.modalTitle : null);

    return { style, modalContent, titleText, iconSrc };
  }

  // Default Modal Behavior
  function bindOpenModal(link) {
    let { style, modalContent, titleText, iconSrc } = initLinkConfig(link);

    // Bind click event to open modal
    addEvents(link, 'click.prevent.stop', () => {
      if (style)
        modal.classList.add("tru-dialog--" + style);
      else 
        modal.setAttribute('class', 'tru-dialog');

      if (modalContent) {
        if (titleText)
          title.innerHTML = titleText;
        if (iconSrc)
          icon.setAttribute('src', iconSrc);
        content.innerHTML = modalContent.outerHTML.replace('aria-hidden="true"', 'aria-hidden="false"');
        requestAnimationFrame(() => modal.showModal());
      }
    });

    // Use observer to watch for changes in link attributes
    const observer = new MutationObserver(() => {
      ({ style, modalContent, titleText, iconSrc } = initLinkConfig(link));
    });
    observer.observe(link, { 
      attributes: true, 
      attributeFilter: ['data-style', 'data-modal-id', 'data-icon-src', 'data-modal-title'] 
    });
  }
})
